import { generate } from "@ant-design/colors";

// Исходный цвет darkAlgorithm. Итоговый основной цвет — appBrandPalettes.dark[5].
export const darkBrandSeed = "#17BE6C";

// Светлая шкала задана дизайном, тёмная остаётся штатной генерацией AntD.
// Встроенное семейство green не переопределяем.
export const appBrandPalettes = {
  light: ["#EDF7F2", "#D5EBDF", "#9CC8AE", "#62A584", "#218459", "#027344", "#025D38", "#06492F", "#083723", "#09271B"],
  dark: generate(darkBrandSeed, { theme: "dark" }),
};

export type AppBrandTokens = Record<`appBrand${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10}`, string>;

// AMTDL neutral идёт от светлого к тёмному, как AntD palette tokens 1..10.
export const appNeutralPalette = [
  "#FEFEFE",
  "#F5F8F7",
  "#DDE7E5",
  "#B2BCBB",
  "#899392",
  "#636C6C",
  "#3E4847",
  "#1D2626",
  "#10191A",
  "#060E0F",
] as const;

export type AppNeutralTokens = Record<`appNeutral${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10}`, string>;

// Нейтральная серая шкала: от поверхностей к контрастным оттенкам в каждой теме.
// Нумерация 0..9 сохраняет соответствие прежней светлой шкале gray-0..gray-9.
export const appGrayPalettes = {
  light: ["#FFFFFF", "#FAFAFA", "#F5F5F5", "#F0F0F0", "#D9D9D9", "#BFBFBF", "#8C8C8C", "#595959", "#434343", "#262626"],
  dark: ["#141414", "#1F1F1F", "#262626", "#303030", "#434343", "#595959", "#8C8C8C", "#BFBFBF", "#D9D9D9", "#F0F0F0"],
} as const;

export type AppGrayTokens = Record<`appGray${0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9}`, string>;
